import React, { useContext, useEffect, useRef, useState } from "react";
import FilteringComponenet from "../filtering-component/hoa-filtering-comp";
import TableLayout from '../table-layout/hoa-table-layout';

import MunicipalityController from "../../controller/hoa-muncipality-controller";
import AddMuniciplaities from './hoa-add-municipalities';

import config from "../../hoa-config";

import SuccessMessage from "../success-message/hoa-success-message";
import { GlobalContext } from '../../context/hoa-global-context';

export default function MuncipalitiesDashboard() {

    const { selectedValues, updateSelectedValues, updateView, view:views } = useContext<any>(GlobalContext)

    const { getMunicipalities } = MunicipalityController()

    const [view, setView] = useState( 
        views !== 'view-more-details' ? "list" : 'view'
    );
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('')
    const [previousMuncipality, setPreviousMuncipality] = useState(JSON.parse(JSON.stringify(selectedValues)));

    const headers = config.dashboard['Municipalities']?.tableLayout?.title;
    const columns = config.dashboard['Municipalities']?.tableLayout?.columns;
    const filteringTitle = config.dashboard['Municipalities']?.filterComponent?.title;
    const filteringSubTitle = config.dashboard['Municipalities']?.filterComponent?.subTitle;

    // useEffect(() => {
    //     setView('list');
    // },[views === 'back-to-list']);

    // useEffect(() => {
    //     setMessage("Municipality Removed Succesfully");
    //     setView('list');
    // },[views === 'remove-from-list']);

    useEffect(()=>{
        setPreviousMuncipality(JSON.parse(JSON.stringify(selectedValues)))
    },[views === "update"])

    useEffect(() => {
        if (views === "add") {
			setMessage("Municipality Created Succesfully");
		} else if (views === "update") {
			setMessage("Municipality Updated Succesfully");
		} else if (views === 'back-to-list') {
            setView('list');
            updateView('list');
            return;
        } else if(views === 'remove-from-list') {
            setMessage("Municipality Removed Succesfully");
            setView('list');
            updateView('list');
            return;
        } 
        else if(views === 'view-more-details') {
            setView('view');
			updateView('view');
			return;
        }

        updateView(view);
    },[view,views === 'back-to-list',views === 'remove-from-list',views === 'view-more-details']);

    return (
        <>
            {
                view === 'list' ?
                    <>
                        <FilteringComponenet onAddClick={setView} title={filteringTitle} subTitle={filteringSubTitle} tagType={'Municipality'}/>
                        <TableLayout updateView={setView} updateSelectedValues={updateSelectedValues} fetchResult={getMunicipalities} headers={headers} columns={columns} tagType={'Municipality'} />
                    </> :
                    <AddMuniciplaities previousMuncipality={previousMuncipality} view={view} setView={setView} setSuccess = {setSuccess}/>
            }

            <SuccessMessage
                success={success}
                setSuccess={setSuccess}
                message={message}
            />
        </>
    )
}